<template>
  <section id="affiliate">
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>เครือข่ายแนะนำ</h5>
      </div>
      <div class="ibox-content">
        <div class="form-inline" style="margin-bottom:15px;">
          <!-- <datepicker :bootstrapStyling="true"
            wrapper-class="form-group"
            language="th"
            v-on:selected="onDateSelected('begin', $event)"
            :value="moreParams.range.begin"
            placeholder="FROM">
          </datepicker>
          <datepicker
            :bootstrapStyling="true"
            wrapper-class="form-group"
            language="th"
            v-on:selected="onDateSelected('ended', $event)"
            :value="moreParams.range.ended"
            placeholder="TO">
          </datepicker>
          <button class="btn btn-info" style="margin-bottom:0" @click="filterRange">GO</button>
          <button class="btn btn-default" style="margin-bottom:0" @click="resetFilterRange">RESET</button> -->
        </div>
        <div class="table-responsive table-scrollable table-member-transaction  space-loader" v-bind:class="{ loading: loading }">
          <vuetable ref="vuetable"
            :api-url="apiUrl"
            :append-params="appendParams"
            :http-options="httpOptions"
            :fields="fieldLists"
            @vuetable:loading="onLoading"
            @vuetable:loaded="onLoaded"
            :css="css.table"
            @vuetable:row-clicked="onRowClicked"
            pagination-path="links.pagination"
            @vuetable:pagination-data="onPaginationData">
            <template slot="username" slot-scope="props">
              <a :href="pathToUser(props.rowData.id)">{{ props.rowData.username }}</a>
            </template>
            <template slot="amount" slot-scope="props">
              <span class="text-green" v-if="props.rowData.type === 'deposit'">+{{ props.rowData.amount | number }}</span>
              <span class="text-red" v-else-if="props.rowData.type === 'withdraw'">-{{ props.rowData.amount | number }}</span>
              <span :class="{ 'text-green' : props.rowData.amount >= 0, 'text-red' : props.rowData.amount < 0,  }" v-else>
                <strong><u>{{ props.rowData.amount | number }}</u></strong>
              </span>
            </template>
            <template slot="gain" slot-scope="props">
              <span>
                {{ 
                  (props.rowData.total_bet_credit
                    + props.rowData.total_bet_rolling
                    + props.rowData.total_additional_credit_amount
                    + props.rowData.total_additional_rolling_amount)
                  * 0.0025
                  | number
                }}
              </span>
            </template>
          </vuetable>
        </div>
        <div class="vuetable-pagination clearfix">
          <div class="pull-left">
            <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
          </div>
          <div class="pull-right">
            <vuetable-pagination-bootstrap ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination-bootstrap>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import moment from 'moment'
  import numeral from 'numeral'
  import Datepicker from 'vuejs-datepicker'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
  import VuetablePaginationBootstrap from '../MemberTransactions/VuetablePaginationBootstrap'
  export default {
    name: 'affiliate-members',
    components: {
      Vuetable,
      Datepicker,
      VuetablePaginationBootstrap,
      VuetablePaginationInfo
    },
    props: {
      userId: {
        type: Number
      }
    },
    computed: {
      apiUrl () {
        return `/api/members/${this.userId}/affiliate`
      },
      // dataRows () {
      //   return this.$refs.vuetable.tableData
      // }
    },
    data () {
      return {
        loading:false,
        css: {
          table: {
            tableClass: 'table table-striped table-bordered table-hover'
          }
        },
        fieldLists: [
          {
            name: 'id',
            title: 'User ID'
          },
          {
            name: '__slot:username',
            title: 'Username'
          },
          {
            name: 'credit.credit_chip',
            title: 'ชิปเป็น',
            callback: 'formatNumber',
            sortField: 'credit'
          },
          {
            name: 'credit.rolling_chip',
            title: 'ชิปตาย',
            callback: 'formatNumber',
            sortField: 'rolling'
          },
          {
            name: 'stat.betall',
            title: 'ยอดเดิมพันสะสม',
            callback: 'formatNumber',
            sortField: 'betall'
          },
          {
            name: 'stat.deposit',
            title: 'โอนเข้า',
            callback: 'formatNumber',
            sortField: 'deposit'
          },
          {
            name: 'stat.withdraw',
            title: 'โอนออก',
            callback: 'formatNumber',
            sortField: 'withdraw'
          },
          {
            name: 'stat.settlement',
            title: 'ส่วนต่าง',
            callback: 'formatNumber',
            sortField: 'settlement'
          },
          {
            name: '__slot:gain',
            title: 'ยอด affiliate เดือนที่แล้ว'
          },
          {
            name: 'mobile',
            title: 'เบอร์โทรศัพท์'
          },
          {
            name: 'created_at',
            title: 'วันที่สมัครสมาชิก',
            sortField: 'created_at'
          }
        ],
        appendParams: {
          per_page: 30
        },
        httpOptions: {
          headers: {
            'X-CSRF-TOKEN': window.App.csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + window.App.jwtToken
          }
        }
      }
    },
    mounted () {
      // setTimeout(() => {
      //   console.log(this.dataRows.length)
      // }, 1000)
    },
    methods: {
      transform: (data) => {
        return data
      },
      formatNumber (number) {
        number = Math.floor(number)
        return numeral(number).format('0,0')
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      onRowClicked (data, field, event) {
        //
      },
      onLoading() {
        this.loading = true
      },
      onLoaded() {
        this.loading = false
      },
      pathToUser (id) {
        const firstPath = location.pathname.split('/')[1]
        return `/${firstPath}/member/${id}/show`
      }
    }
  }
</script>
<style>
  tr .sortable {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/AffiliateMembers/AffiliateMembers.vue